export default [
    {
        key: 'checkboxes',
        label: '',
        variant: 'column-xs'
    },
    {
        key: 'images',
        label: 'Images',
        variant: 'column-img'
    },
    {
        key: 'name',
        label: 'Name',
        sortable: true,
        variant: 'column-img'
    },
    {
        key: 'sku',
        label: 'SKU',
        sortable: true
    },
    {
        key: 'fnsku',
        label: 'FNSKU',
        sortable: true
    },
    {
        key: 'marketplaceRelation.amazonProductId',
        label: 'ASIN',
        sortable: true
    },
    {
        key: 'condition',
        label: 'Condition',
        sortable: true,
        variant: 'column-md'
    },
    {
        key: 'stock.incoming',
        label: 'Incoming',
        sortable: true,
        variant: 'column-md'
    },
    {
        key: 'stock.available',
        label: 'Available',
        sortable: true,
        variant: 'column-md'
    }
]



// WEBPACK FOOTER //
// ./src/assets/js/columns/replenishmentAddProducts.js